import { useRef, useState, useEffect } from 'react';
import clsx from 'clsx';

import { useLanguage } from '@providers/LanguageProvider';
import { LANGUAGES } from '@i18n/languages';

import css from './LangSwitch.module.scss';

const LangSwitch = ({ isMobile }) => {
  const bodyRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [maxHeight, setMaxHeight] = useState('0px');

  const { lang, changeLanguage } = useLanguage();

  const current = LANGUAGES[lang];
  const others = Object.values(LANGUAGES).filter(l => l.code !== lang);

  useEffect(() => {
    if (!bodyRef.current) return;

    if (isMobile) {
      setMaxHeight(isOpen ? `${bodyRef.current.scrollHeight}px` : '0px');
    } else {
      setMaxHeight('');
    }
  }, [isMobile, isOpen]);

  const handleToggle = () => {
    if (!isMobile) return;
    setIsOpen(prev => !prev);
  };

  const handleChange = code => {
    changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <nav
      className={clsx(
        css.lang,
        !isMobile && css.header,
        isMobile && css.mobmenu,
        isOpen && css.isOpen
      )}
      aria-label="Language switcher"
    >
      <button
        type="button"
        className={css.lang__current}
        onClick={handleToggle}
        aria-expanded={isOpen}
      >
        {current.code}
      </button>

      <ul className={css.lang__list} ref={bodyRef} style={{ maxHeight }}>
        {others.map(l => (
          <li key={l.code}>
            <button type="button" onClick={() => handleChange(l.code)}>
              <span className={css.code}>{l.code}</span>
              <span className={css.label}>{l.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default LangSwitch;
